var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53753 0.337651C7.71309 0.513433 7.8117 0.751713 7.8117 1.00015C7.8117 1.24859 7.71309 1.48687 7.53753 1.66265L3.20003 6.00015L7.53753 10.3377C7.62964 10.4235 7.70352 10.527 7.75476 10.642C7.806 10.757 7.83355 10.8811 7.83577 11.007C7.83799 11.1329 7.81483 11.2579 7.76768 11.3746C7.72053 11.4914 7.65035 11.5974 7.56133 11.6864C7.4723 11.7755 7.36626 11.8457 7.24953 11.8928C7.13279 11.94 7.00776 11.9631 6.88188 11.9609C6.756 11.9587 6.63186 11.9311 6.51686 11.8799C6.40186 11.8286 6.29836 11.7548 6.21253 11.6627L1.21253 6.66265C1.03697 6.48687 0.938354 6.24859 0.938354 6.00015C0.938354 5.75171 1.03697 5.51343 1.21253 5.33765L6.21253 0.337651C6.38831 0.162088 6.62659 0.0634766 6.87503 0.0634766C7.12347 0.0634766 7.36175 0.162088 7.53753 0.337651Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTable);
export default __webpack_public_path__ + "static/media/arrowTable.ce05c45d83030936b8c2d848b3a55d11.svg";
export { ForwardRef as ReactComponent };